export function logEmailMakerError(context: string, error: unknown): void {
  window.PMW.log(`[EmailMaker] ${context}`, error);
}
